import React, { ComponentProps } from 'react';
import {
  PaginationProps as AntdPaginationProps,
  Table as AntdTable,
  TablePaginationConfig as AntdTablePaginationConfig,
  TableProps as AntdTableProps,
} from 'antd';
import { FilterDropdownProps } from 'antd/es/table/interface';
import { ColumnsType as AntdColumnsType } from 'antd/lib/table';
import classNames from 'classnames';
import { SearchOutlined } from '@ant-design/icons';
import { TextComponent } from '../../index';

import './table.scss';

export type TablePaginationConfig = AntdTablePaginationConfig;
export type PaginationProps = AntdPaginationProps;
export type ColumnsType<T> = AntdColumnsType<T>;

export type TableProps<T> = AntdTableProps<T> & {
  rowHoverable?: boolean;
};

export const Table = <T extends Record<string, any>>({
  className,
  rowHoverable = true,
  ...antdProps
}: TableProps<T>) => {
  return (
    <div className="the5ers-table">
      <AntdTable<T>
        pagination={{
          hideOnSinglePage: true,
        }}
        {...antdProps}
        rowClassName={classNames('the5ers-table-row', className)}
        className={classNames({
          'disabled-hoverable': !rowHoverable,
        })}
      />
    </div>
  );
};

export const TableSummaryRow = (
  props: ComponentProps<typeof AntdTable.Summary.Row>,
) => {
  return <AntdTable.Summary.Row {...props} />;
};

export const TableSummaryCell = (
  props: ComponentProps<typeof AntdTable.Summary.Cell>,
) => {
  return <AntdTable.Summary.Cell {...props} />;
};

export const getTableFilterProps = <T extends Record<string, string>>(
  options: T,
  filteredValue: T[keyof T][] | undefined,
): ColumnsType<any>[0] => ({
  filters: createFilters(options),
  filteredValue: filteredValue || [],
});

const createFilters = (options: Record<string, string>) =>
  Object.values(options).map((value) => ({
    text: <TextComponent capitalize>{value}</TextComponent>,
    value,
  }));

export const getTableSearchProps = <T extends string>(
  key: T,
  component: (key: T, close: () => void) => React.JSX.Element,
  active?: boolean,
) => {
  return {
    filterDropdown: (props: FilterDropdownProps) => component(key, props.close),
    filterIcon: (
      <SearchOutlined className={`search-outlined ${active ? 'active' : ''}`} />
    ),
  };
};
